import { render, staticRenderFns } from "./Flyer.vue?vue&type=template&id=94e15d1a&scoped=true"
import script from "./Flyer.vue?vue&type=script&lang=js"
export * from "./Flyer.vue?vue&type=script&lang=js"
import style0 from "./Flyer.vue?vue&type=style&index=0&id=94e15d1a&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e15d1a",
  null
  
)

export default component.exports